<template>
    <SubpageHeader :pageId="categoryId" :pageType="pageType" :website="websiteData" v-if="categoryId && pageType"></SubpageHeader>

    <transition name="fade" appear>
        <WebsiteDetail :website="websiteData" :pageType="pageType" :pageId="pageId" v-if="websiteData"></WebsiteDetail>
    </transition>
</template>

<script>
import axios from "axios";
import WebsiteDetail from "./WebsiteDetail";
import SubpageHeader from "../elements/SubpageHeader";

export default {
    name: "Website",
    components: {
        WebsiteDetail,
        SubpageHeader
    },
    data() {
        return {
            WEBSITE_DATA: '/api/krainaabc/website?device=www&id=',
            websiteData: [],
        };
    },
    computed: {
        // website() {
        //     return this.$store.getters.getNewsData
        // },
        categoryId() {
            if(this.websiteData && this.websiteData.breadcrumbs && this.websiteData.breadcrumbs[0] && this.websiteData.breadcrumbs[0]._id) {
                return this.websiteData.breadcrumbs[0]._id;
            }
            return null;
        },
        pageType() {
            if(this.$route.params.type) {
                return this.$route.params.type;
            } else {
                return window.__pageSettings.type;
            }
        },
        pageId() {
            if(this.$route.params.id) {
                return parseInt(this.$route.params.id);
            } else {
                return window.__pageSettings.id;
            }
        }
    },
    methods: {
        getWebsiteData() {
            axios.get(`${this.WEBSITE_DATA}${this.pageId}`).then((response) => {
                if (response.status === 200) {
                    if(response.data && response.data.data) {
                        this.websiteData = response.data.data;
                    }
                }
            });            
        }
    },
    mounted() {
        this.getWebsiteData();
    }
};
</script>